var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _vm._v(" " + _vm._s(_vm.websitetype) + " Location & Hours ")
      ]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      " If your " +
                        _vm._s(_vm.websitetype) +
                        " publishes operation hours, select them here. Otherwise, click Next Step. "
                    )
                  ]),
                  _c("v-switch", {
                    attrs: {
                      "true-value": 1,
                      "false-value": 0,
                      label: "My " + _vm.websitetype + " has hours"
                    },
                    model: {
                      value: _vm.businessHours,
                      callback: function callback($$v) {
                        _vm.businessHours = $$v
                      },
                      expression: "businessHours"
                    }
                  }),
                  _vm.businessHours ? _c("work-schedule") : _vm._e()
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("v-switch", {
                    attrs: {
                      label: "My ".concat(
                        _vm.websitetype,
                        " has a physical address"
                      )
                    },
                    model: {
                      value: _vm.hasAddress,
                      callback: function callback($$v) {
                        _vm.hasAddress = $$v
                      },
                      expression: "hasAddress"
                    }
                  })
                ],
                1
              ),
              _vm.hasAddress
                ? [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          attrs: {
                            label: "Address",
                            name: "address",
                            autocomplete: "new-password"
                          },
                          model: {
                            value: _vm.address,
                            callback: function callback($$v) {
                              _vm.address = $$v
                            },
                            expression: "address"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          attrs: {
                            label: "City",
                            name: "city",
                            autocomplete: "new-password"
                          },
                          model: {
                            value: _vm.city,
                            callback: function callback($$v) {
                              _vm.city = $$v
                            },
                            expression: "city"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          attrs: {
                            label: "State",
                            name: "state",
                            autocomplete: "new-password"
                          },
                          model: {
                            value: _vm.state,
                            callback: function callback($$v) {
                              _vm.state = $$v
                            },
                            expression: "state"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          attrs: {
                            label: "Postcode",
                            name: "postcode",
                            autocomplete: "new-password"
                          },
                          model: {
                            value: _vm.postcode,
                            callback: function callback($$v) {
                              _vm.postcode = $$v
                            },
                            expression: "postcode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c("gg-select", {
                          attrs: {
                            items: _vm.countries,
                            label: "Country",
                            name: "country",
                            "item-text": "name",
                            "item-value": "name"
                          },
                          model: {
                            value: _vm.country,
                            callback: function callback($$v) {
                              _vm.country = $$v
                            },
                            expression: "country"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }